import { socket } from "../index";
import { openAlert } from "../../atoms/common";

const listenReceiveLackBulletWhenJoinProject = () => {
  socket?.on('RECEIVE_LACK_BULLET_WHEN_JOIN_PROJECT', () => {
    openAlert('보유한 보석이 부족하여, 해당 프리미엄 방에 입장할 수 없습니다.', () => {
        window.location.href = '/chatting-app/waiting-room';
    });
  });
}

export default listenReceiveLackBulletWhenJoinProject;